<div class="page-container">
  <app-list-menu
    [items]="items"
    [breadcrumbs]="breadcrumbs"
  ></app-list-menu>
   <app-restaurant-footer></app-restaurant-footer>
</div>

